exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar-container {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.app-wrapper {\r\n  color: #111;\r\n  position: relative;\r\n  text-align: left;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\napp-mobile-calendar {\r\n  display: block;\r\n  max-width: 800px;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.angular-desktop {\r\n  -ms-flex-align: center;\r\n      align-items: center; \r\n  display: -ms-flexbox; \r\n  display: flex;\r\n  -ms-flex-flow: column;\r\n      flex-flow: column;\r\n  -ms-flex-pack: center;\r\n      justify-content: center;\r\n  height: 100%;\r\n}\r\n.angular-mobile {\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-flow: column;\r\n      flex-flow: column;\r\n  -ms-flex-pack: start;\r\n      justify-content: flex-start;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/Components/app/app.component.css
// module id = ../../../../../src/app/Components/app/app.component.css
// module chunks = 1